import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { Box, CircularProgress, useTheme, useMediaQuery } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  imageContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: "100%",
    height: "100%",
    overflow: "hidden",
    backgroundColor: "#1976d2",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    objectPosition: "center",
    display: "block",
  },
  loadingContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

const IframeContent = ({ imageUrls, isConfigLoading, onLoad }) => {
  const classes = useStyles();
  const theme = useTheme();
  const imgRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [imageSrc, setImageSrc] = useState("");

  // Detect device type based on breakpoints
  // xs: 0-599px (Mobile)
  // sm: 600-959px (Tablet)
  // md+: 960px+ (Desktop)
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'sm'));

  useEffect(() => {
    if (isConfigLoading) {
      setImageSrc("");
      setLoading(true);
      return;
    }

    let nextImageSrc = imageUrls?.desktopImageUrl || "";
    if (isMobile) {
      nextImageSrc = imageUrls?.mobileImageUrl || nextImageSrc;
    } else if (isTablet) {
      nextImageSrc = imageUrls?.tabletImageUrl || nextImageSrc;
    }

    setImageSrc((prev) => {
      if (prev !== nextImageSrc) {
        setLoading(Boolean(nextImageSrc));
      }
      return nextImageSrc;
    });
  }, [
    imageUrls,
    isConfigLoading,
    isMobile,
    isTablet,
  ]);

  // Cached images may not fire `onLoad` when src changes; clear spinner if already decoded.
  useLayoutEffect(() => {
    const el = imgRef.current;
    if (!imageSrc || !el) {
      return;
    }
    if (el.complete && el.naturalHeight > 0) {
      setLoading(false);
    }
  }, [imageSrc]);

  const handleLoad = () => {
    setLoading(false);
    if (onLoad) {
      onLoad();
    }
  };

  const handleError = () => {
    setLoading(false);
    if (onLoad) {
      onLoad();
    }
  };

  return (
    <Box className={classes.imageContainer}>
      {loading && (
        <Box className={classes.loadingContainer}>
          <CircularProgress style={{ color: "#1976d2" }} />
        </Box>
      )}
      {imageSrc && (
        <img
          ref={imgRef}
          src={imageSrc}
          alt="SkyGeni Login"
          className={classes.image}
          onLoad={handleLoad}
          onError={handleError}
        />
      )}
    </Box>
  );
};

export default IframeContent;
